import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SettingFieldTable from '@/views/mixin/SettingFieldTable';
import MesTable from '@/api/MesTable/index.js';
import fastSearch from '@/components/fast-search';
import { assign } from 'xe-utils';
import util from '@/libs/util';
import { ExportListData } from '@/api/DeliveryNoteReport';
import ExportJsonExcel from 'js-export-excel';
var mesTable = MesTable('ScmErpPo/GetErpOsorderAdvancedQuery');
export default {
  mixins: [SettingFieldTable({
    defaultLoadDataApi: function defaultLoadDataApi(e) {
      return mesTable.LoadData(e);
    }
  })],
  components: {
    fastSearch: fastSearch
  },
  data: function data() {
    return {
      mainTable: [],
      code: '',
      formData: {
        Page: 1,
        // 当前页
        Limit: 10,
        // 分页大小
        Data: {
          VENDOR_CODE: util.getVENDOR_CODE(),
          // VENDOR_CODE: '2.1.003',
          ORGANIZE_ID: util.cookies.get('ORG_ID')
        }
      },
      pageInfo: {
        TotalCount: null,
        PageSize: 10,
        PageIndex: 1
      },
      isShowVENDOR_CODE: false,
      isDisable: false,
      loading: false
    };
  },
  created: function created() {
    // console.log('columnsWhere', this.columnsWhere)
    this.isShowVENDOR_CODE = !util.getVENDOR_CODE(); // this.getLoadData()
  },
  mounted: function mounted() {
    if (this.isShowVENDOR_CODE === false) {
      this.getLoadData();
    }
  },
  methods: {
    // 搜索
    search: function search() {
      this.formData.Page = this.pageInfo.PageIndex;
      this.getLoadData();
    },
    TranslationSTATUS: function TranslationSTATUS(STATUS) {
      switch (STATUS) {
        case 1:
          return '未处理';
        // 未处理

        case 2:
          return '审核';
        // 审核

        case 3:
          return '作废';
        // 作废

        case 4:
          return '在途';
        // 在途
      }
    },
    TranslationDN_TYPE: function TranslationDN_TYPE(DN_TYPE) {
      switch (DN_TYPE) {
        case '1':
          return '采购送货单';
        // 未处理

        case '2':
          return '委外送货单';
        // 审核
      }
    },
    handelExportListData: function handelExportListData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var sheetOptions, option, toExcel;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.mainTable.length === 0) {
                  _this.$message.warning('导出失败，数据为空');
                } else {
                  sheetOptions = _this.mainKeys.filter(function (v) {
                    return v.IS_VISIBLE === 'Y';
                  });
                  option = {
                    fileName: '委外订单报表',
                    datas: [{
                      sheetData: _this.mainTable,
                      sheetName: '委外订单报表',
                      sheetFilter: sheetOptions.map(function (v) {
                        return v.FIELD_NAME;
                      }),
                      sheetHeader: sheetOptions.map(function (v) {
                        return v.FIELD_CAPTION;
                      })
                    }]
                  };
                  toExcel = new ExportJsonExcel(option);
                  toExcel.saveExcel();

                  _this.$message.success('报表数据导出成功');
                } // this.$openLoading()
                // const res = await ExportListData(this.formData)
                // this.$closeLoading()
                // // console.log('导出res',res);
                // if (res.code === 0) {
                //   window.open(this.$store.getters.getVUE_APP_DOWN + res.data)
                // } else {
                //   this.$message.warning('数据导出失败----' + res.message)
                // }


              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // 点击页size
    handleSizeChange: function handleSizeChange(size) {
      console.log('点击size');
      this.formData.Limit = size;
      this.getLoadData();
    },
    // 点击页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.formData.Page = index;
      this.getLoadData();
    },
    getLoadData: function getLoadData() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                _context2.next = 3;
                return mesTable.LoadData(_this2.formData);

              case 3:
                res = _context2.sent;
                _this2.loading = false;

                if (res.code === 0) {
                  _this2.mainTable = res.data.Items.map(function (v) {
                    v.statusStyle = util.func.switchColor(v);
                    return v;
                  });
                  _this2.pageInfo.TotalCount = res.data.TotalCount;
                  _this2.pageInfo.PageSize = res.data.PageSize;
                  _this2.pageInfo.PageIndex = res.data.PageIndex;
                  console.log('表格数据 res', _this2.mainTable);
                } else {
                  _this2.$message.warning(res.message);
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    fastSearch: function fastSearch(searchData) {
      this.formData.ParamList = this.mergeParamList(searchData.ParamList, this.formData.ParamList);
      this.getLoadData();
    }
  }
};